import en from './en';
import fr from './fr';
import {locale} from 'shared/core';

function getLocalization() {
  switch (locale) {
    case 'en': return en;
    case 'fr': return fr;
    default: throw new Error(`Language ${locale} is not supported by DataTables. Download a language pack for ${locale} from here: https://datatables.net/plug-ins/i18n/`);
  }
}

export default getLocalization();
